<template>
  <tr :class="{ 'is-Selected': isChecked }">
    <td>
      <input type="checkbox" :value="item.id" @change="onChange" :checked="isChecked" :id="`sel${index + 1}`" />
    </td>

    <template v-for="cell in cells">
      <td v-if="cell.type === 'title'" :class="cell.class" :key="cell.id">
        <router-link class="postsTable__ItemTitle" :to="{ name: editURL, params, query }" append>
          <span
            v-if="item.status && Array.isArray(searchParams.status) && searchParams.status.length > 0"
            :class="`postsTable__ItemType--Status postsTable__ItemType--${capitalize(item.status)}`"
            >{{ item.status.replace(/_/g, ' ') }}</span
          >
          <template v-if="cell.class === 'has-Icon'">
            <span v-if="item.type === 'youtube'" class="postsTable__ItemType--Icon"><icon name="youtube"></icon></span>

            <div v-else-if="item.type === 'event'" class="postsTable__ItemType--Date">
              <strong>{{ moment(item.start_datetime).format('DD') }}</strong>
              <span>{{ moment(item.start_datetime).format('MMM') }}</span>
              <span>{{ moment(item.start_datetime).format('YYYY') }}</span>
            </div>

            <span v-else-if="item.type === 'digital_publication'" class="postsTable__ItemType">DP</span>
            <span v-else class="postsTable__ItemType">{{ item.type }}</span>
          </template>
          <span v-html="getProperty('title').replace('<br>', '<span class=break>br</span>')"></span>
        </router-link>
        <p v-if="l10n[lang].source_name" class="postsTable__ItemCategory">
          {{ l10n[lang].source_name }}
        </p>
        <ul class="postsTable__ItemActions">
          <template>
            <li>
              <router-link :to="{ name: editURL, params, query }" append>{{
                $store.getters.getStringTranslation('edit')
              }}</router-link>
            </li>
          </template>

          <li>
            <button @click="disable()">{{ disableLabel }}</button>
          </li>
        </ul>
      </td>

      <td v-else-if="cell.type.includes('contents.additionals.clause_properties')" :key="cell.id">
        {{ item.contents.additionals.clause_properties[cell.type.split('.')[cell.type.split('.').length - 1]] }}
      </td>

      <td v-else-if="cell.type === 'description'" :key="cell.id">
        <icon v-if="getProperty('description') && getProperty('description').length > 0" name="check"></icon>
        <icon v-else name="times"></icon>
      </td>

      <td v-else-if="cell.type === 'featured'" :key="cell.id">
        <icon v-if="item.is_featured === false" name="star"></icon>
        <icon v-else name="star" weight="solid"></icon>
      </td>

      <td v-else-if="cell.type === 'languages'" :class="cell.class" :key="cell.id">
        <div class="postsTable__LanguagesList">
          <icon class="postsTable__LanguagesIcon" name="question-circle" />
          <ul>
            <li v-for="lang in cell.label.filter((l) => l10n[l.toLowerCase()])" :key="lang.id">
              <span>{{ lang }}</span>
            </li>
          </ul>
        </div>
      </td>

      <td
        v-else-if="
          ['sector', 'issue', 'organisation', 'country', 'region', 'clause_theme', 'clause_type'].includes(cell.type)
        "
        :key="cell.id"
      >
        <span v-for="(tag, tagIndex) in getTagByType(cell.type)" :key="tag.id">{{
          `${tagIndex !== 0 ? ' &bull; ' : ''}${getProperty('name', tag.l10n)}`
        }}</span>
        <template v-if="getTagByType(cell.type).length === 0">&mdash;</template>
      </td>

      <td v-else-if="cell.type === 'status'" :key="cell.id">
        <icon v-if="getProperty('status') === 'published'" name="eye"></icon>
        <icon v-else name="eye-slash"></icon>
      </td>

      <td v-else-if="cell.type === 'date'" :key="cell.id">
        {{ moment(item.inserted_at).format('DD.MM.YY.') }}
      </td>
      <td v-else-if="cell.type === 'updated'" :key="cell.id">
        <template v-if="item.contents.additionals && item.contents.additionals.last_edited_user">
          <span
            v-if="item.contents.additionals && item.contents.additionals.last_edited_user.length > 0"
            class="lastUpdatedUser"
            >{{ item.contents.additionals.last_edited_user[0].name }}
          </span>
        </template>
        {{ moment(item.updated_at).format('DD.MM.YY.') }}
      </td>

      <td v-else-if="cell.type === 'endorsements'" :key="cell.id">{{ item.endorsements }}</td>
    </template>
  </tr>
</template>

<script>
import HTTP from '@/http-common.js'
import EventBus from '@/bus.js'

import GetTagByType from '@/components/mixins/GetTagByType.js'
import IsChecked from '@/components/mixins/IsChecked.js'
import ReduceItemData from '@/components/mixins/ReduceItemData.js'
import DisableItem from '@/components/mixins/DisableItem.js'
import GetProperty from '@/components/mixins/GetProperty.js'
import Capitalize from '@/components/mixins/Capitalize.js'

export default {
  props: ['item', 'index', 'selected', 'lang', 'editor', 'buttons', 'cells', 'searchParams', 'parent'],
  mixins: [GetTagByType, IsChecked, ReduceItemData, DisableItem, GetProperty, Capitalize],
  name: 'ListingItem',
  data() {
    return {
      status: this.item.status,
    }
  },
  computed: {
    params() {
      return {
        id: this.item.id,
      }
    },
    query() {
      const item = this.parent ? this.parent : this.item

      return {
        lang: this.lang,
        search: JSON.stringify(this.searchParams),
        api_keys: JSON.stringify(item.websites.map((website) => website.api_key)),
      }
    },
    editURL() {
      if (this.buttons && this.buttons.length > 0) {
        if (this.l10n[this.lang].source_name && this.editor.edit) {
          return this.editor.edit.name
        } else if (this.editor.manage) {
          return this.editor.manage.name
        }
      }

      return this.editor[Object.keys(this.editor)[0]].name
    },
  },
  created() {
    this.transformTranslationData(this.item.l10n)

    EventBus.$on('actionFeature', (ids) => {
      ids = JSON.parse(ids)
      if (ids.includes(this.item.id)) {
        this.item.is_featured = !this.item.is_featured
        let apiKeys = []
        if (this.item.websites) apiKeys = this.item.websites.map((website) => website.api_key)
        HTTP.post(`resource/update/${this.item.id}`, {
          is_featured: this.item.is_featured,
          api_keys: apiKeys,
        })
      }
    })

    EventBus.$on('actionDisable', (ids) => {
      ids = JSON.parse(ids)
      if (ids.includes(this.item.id)) {
        this.disabler()
      }
    })
  },
  watch: {
    // Re-apply translation transformation if title has been updated
    'item.l10n'() {
      this.transformTranslationData(this.item.l10n)
    },
  },
}
</script>
